export const SUCCESSFUL_GET_QUOTASTOPAY = "SUCCESSFUL_GET_QUOTASTOPAY";
export const UPDATE_QUOTAS_SELECTION = "UPDATE_QUOTAS_SELECTION";
export const UPDATE_MAKE_REQUEST_QUOTAS = "UPDATE_REQUEST_QUOTAS";
export const UPDATE_SALE_ORDER = "UPDATE_SALE_ORDER";
export const UPDATE_SELECTED_QUOTA_ID = "UPDATE_SELECTED_QUOTA_ID";
export const UPDATE_PAYMENT_METHOD = "UPDATE_PAYMENT_METHOD";
export const GENERAL_UPDATE_QUOTAS_TO_PAY = "GENERAL_UPDATE_QUOTAS_TO_PAY";
export const UPDATE_ONLINE_PAYMENT_ID = "UPDATE_ONLINE_PAYMENT_ID";
export const UPDATE_DRAFT_SALEORDER_PAYMENT_TYPE = "UPDATE_DRAFT_SALEORDER_PAYMENT_TYPE";
export const UPDATE_RESERVE_AMOUNT = "UPDATE_RESERVE_AMOUNT";
export const UPDATE_SALEORDER_AT_QUOTAS_TO_PAY = "UPDATE_SALEORDER_AT_QUOTAS_TO_PAY";


// WEBPACK FOOTER //
// ./src/reducers/quotastopay/actionConst.js